
import React from 'react';
import { CommandItem } from '@/components/ui/command';
import { CheckIcon, MapPinIcon, HeartIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import { LocationOption } from '@/types/weather';

interface LocationItemProps {
  location: LocationOption;
  isSelected: boolean;
  isFavorite: boolean;
  onSelect: (location: LocationOption) => void;
  onToggleFavorite: (location: LocationOption) => void;
}

const LocationItem: React.FC<LocationItemProps> = ({ 
  location, 
  isSelected,
  isFavorite,
  onSelect,
  onToggleFavorite
}) => {
  const handleFavoriteClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent selection when clicking the favorite icon
    onToggleFavorite(location);
  };

  return (
    <CommandItem
      key={location.id}
      value={location.name}
      onSelect={() => onSelect(location)}
      className="flex justify-between items-center py-3"
    >
      <div className="flex items-center gap-2 truncate max-w-[70%]">
        <MapPinIcon className="h-4 w-4 flex-shrink-0 text-weather-blue" />
        <span className="truncate">{location.name}, {location.country}</span>
      </div>
      <div className="flex items-center ml-auto">
        <HeartIcon
          className={cn(
            "h-5 w-5 cursor-pointer transition-colors mr-2",
            isFavorite ? "fill-red-500 text-red-500" : "text-gray-300 hover:text-gray-400"
          )}
          onClick={handleFavoriteClick}
        />
        <CheckIcon
          className={cn(
            "h-4 w-4",
            isSelected ? "opacity-100" : "opacity-0"
          )}
        />
      </div>
    </CommandItem>
  );
};

export default LocationItem;
